import type { Dict } from "../../../../shared/i18n";

/** Переводы: русский исходник → [литовский, английский] */
export default {
  // общие кнопки и подписи панелей
  "Сохранить": ["Išsaugoti", "Save"],
  "Сохранено": ["Išsaugota", "Saved"],
  "Отмена": ["Atšaukti", "Cancel"],
  "Добавить": ["Pridėti", "Add"],
  "Удалить": ["Ištrinti", "Delete"],
  "Открыть": ["Atidaryti", "Open"],
  "Отправить": ["Siųsti", "Send"],
  "Готово": ["Atlikta", "Done"],
  "Нет": ["Ne", "No"],
  "Вернуть": ["Anuliuoti", "Undo"],
  "Скопировано": ["Nukopijuota", "Copied"],
  "Копировать": ["Kopijuoti", "Copy"],
  "Название": ["Pavadinimas", "Name"],
  "Отменено": ["Atšaukta", "Undone"],
  "{n} место|{n} места|{n} мест": ["{n} vieta|{n} vietos|{n} vietų", "{n} place|{n} places"],

  // панель поездки (panels/TripPanel.tsx)
  "Ссылка-приглашение скопирована": ["Kvietimo nuoroda nukopijuota", "Invite link copied"],
  "Участники · {n}": ["Dalyviai · {n}", "Members · {n}"],
  "Сейчас онлайн": ["Šiuo metu tinkle", "Online now"],
  "(вы)": ["(jūs)", "(you)"],
  "Пригласить друзей": ["Pakviesti draugus", "Invite friends"],
  "могут редактировать": ["gali redaguoti", "can edit"],
  "только смотреть": ["gali tik peržiūrėti", "can only view"],
  "Получить ссылку": ["Gauti nuorodą", "Get link"],
  "Ссылка действует 14 дней, до 10 человек. Друг входит через Google и сразу видит поездку.": [
    "Nuoroda galioja 14 dienų ir tinka iki 10 žmonių. Draugas prisijungia per Google ir iškart mato kelionę.",
    "The link is valid for 14 days for up to 10 people. Friends sign in with Google and see the trip right away.",
  ],
  "Журнал изменений": ["Pakeitimų žurnalas", "Activity log"],
  "Отменить это изменение": ["Atšaukti šį pakeitimą", "Undo this change"],
  "Параметры поездки": ["Kelionės nustatymai", "Trip settings"],
  "Подзаголовок": ["Paantraštė", "Subtitle"],
  "Начало": ["Pradžia", "Start"],
  "Конец": ["Pabaiga", "End"],
  "Описание и предпочтения группы": ["Aprašymas ir grupės pageidavimai", "Description and group preferences"],
  "ИИ учитывает это при планировании: бюджет, темп, что любите, ограничения.": [
    "DI į tai atsižvelgia planuodamas: biudžetas, tempas, ką mėgstate, apribojimai.",
    "The AI takes this into account when planning: budget, pace, what you like, restrictions.",
  ],
  "Офлайн и экспорт": ["Be interneto ir eksportas", "Offline and export"],
  "План сохраняется на этом устройстве и открывается без интернета. Карта доступна офлайн для районов, которые вы уже открывали.": [
    "Planas saugomas šiame įrenginyje ir atsidaro be interneto. Žemėlapis be interneto veikia tose vietovėse, kurias jau atidarėte.",
    "The plan is stored on this device and opens without internet. The map works offline for areas you have already opened.",
  ],
  "План сохраняется на этом устройстве и открывается без интернета (копия от {time}). Карта доступна офлайн для районов, которые вы уже открывали.": [
    "Planas saugomas šiame įrenginyje ir atsidaro be interneto (kopija išsaugota {time}). Žemėlapis be interneto veikia tose vietovėse, kurias jau atidarėte.",
    "The plan is stored on this device and opens without internet (copy saved {time}). The map works offline for areas you have already opened.",
  ],
  "Экспорт JSON": ["Eksportuoti JSON", "Export JSON"],
  "Печать плана": ["Spausdinti planą", "Print plan"],
  "Оформление": ["Išvaizda", "Appearance"],
  "Авто": ["Automatinė", "Auto"],
  "Светлая": ["Šviesi", "Light"],
  "Тёмная": ["Tamsi", "Dark"],
  "ИИ: {model}": ["DI: {model}", "AI: {model}"],
  "ИИ не подключён": ["DI neprijungtas", "AI not connected"],
  "Выйти": ["Atsijungti", "Sign out"],
  "Роль изменена": ["Vaidmuo pakeistas", "Role changed"],
  "Подключить к Claude (MCP)": ["Prijungti prie Claude (MCP)", "Connect to Claude (MCP)"],
  "Управляйте поездками из Claude: «добавь в план…», «что у нас 12 апреля?», «покажи на карте» — карта сдвинется здесь же. Ссылка личная: она даёт доступ ко всем вашим поездкам.": [
    "Valdykite keliones iš Claude: „įtrauk į planą…“, „kas suplanuota balandžio 12 d.?“, „parodyk žemėlapyje“ – žemėlapis pasislinks čia pat. Nuoroda asmeninė: ji suteikia prieigą prie visų jūsų kelionių.",
    "Manage your trips from Claude: “add to the plan…”, “what do we have on 12 April?”, “show it on the map” — the map moves right here. The link is personal: it gives access to all your trips.",
  ],
  "Ссылка создана — сохраните её сейчас, второй раз она не покажется": [
    "Nuoroda sukurta – išsisaugokite ją dabar, antrą kartą ji nebus parodyta",
    "Link created — save it now, it won't be shown again",
  ],
  "Настройки → Коннекторы → Добавить свой коннектор → вставить ссылку.": [
    "Settings → Connectors → Add custom connector → įklijuokite nuorodą.",
    "Settings → Connectors → Add custom connector → paste the link.",
  ],
  "Создать ссылку для Claude": ["Sukurti nuorodą Claude", "Create a link for Claude"],
  "создан {time}": ["sukurtas {time}", "created {time}"],
  "использовался {time}": ["naudotas {time}", "last used {time}"],
  "ещё не использовался": ["dar nenaudotas", "not used yet"],
  "Ключ отключён": ["Raktas atjungtas", "Key revoked"],
  "отключить": ["atjungti", "revoke"],

  // деньги (panels/BudgetPanel.tsx)
  "Потрачено / записано": ["Išleista / užrašyta", "Spent / recorded"],
  "≈ {sum} на человека": ["≈ {sum} vienam žmogui", "≈ {sum} per person"],
  "В плане (цены пунктов)": ["Plane (punktų kainos)", "In the plan (item prices)"],
  "По категориям": ["Pagal kategorijas", "By category"],
  "Кто кому должен": ["Kas kam skolingas", "Who owes whom"],
  "заплатил {sum}": ["sumokėjo {sum}", "paid {sum}"],
  "Расходы · {n}": ["Išlaidos · {n}", "Expenses · {n}"],
  "Записывайте брони и траты — посчитаем, кто кому сколько должен.": [
    "Užrašykite rezervacijas ir išlaidas – suskaičiuosime, kas kam kiek skolingas.",
    "Record bookings and spending — we'll work out who owes whom and how much.",
  ],
  "платил {name}": ["mokėjo {name}", "paid by {name}"],
  "Название и сумма": ["Įveskite pavadinimą ir sumą", "Enter a title and amount"],
  "Новый расход": ["Nauja išlaida", "New expense"],
  "Что": ["Už ką", "What for"],
  "Ужин в Хойане": ["Vakarienė Hojane", "Dinner in Hoi An"],
  "Сумма": ["Suma", "Amount"],
  "Валюта": ["Valiuta", "Currency"],
  "Категория": ["Kategorija", "Category"],
  "Дата": ["Data", "Date"],
  "Кто платил": ["Kas mokėjo", "Paid by"],
  "Делим между (пусто — на всех)": ["Padalyti tarp (nieko nepažymėjus – visiems)", "Split between (none selected — everyone)"],

  // чек-лист (panels/ChecklistPanel.tsx)
  "показать все": ["rodyti visas", "show all"],
  "скрыть сделанное": ["slėpti atliktas", "hide done"],
  "Новая задача…": ["Nauja užduotis…", "New task…"],
  "до {date}": ["iki {date}", "by {date}"],
  "кто делает?": ["kas atliks?", "who's on it?"],
  "Задача удалена": ["Užduotis ištrinta", "Task deleted"],

  // источники (sources/SourcesPanel.tsx)
  "в очереди": ["eilėje", "queued"],
  "скачиваю текст…": ["atsisiunčiamas tekstas…", "fetching text…"],
  "ИИ разбирает…": ["DI analizuoja…", "AI is processing…"],
  "готово": ["paruošta", "ready"],
  "ждёт ИИ": ["laukia DI", "waiting for AI"],
  "ошибка": ["klaida", "error"],
  "Источник": ["Šaltinis", "Source"],
  "Открыть статью": ["Atidaryti straipsnį", "Open article"],
  "На карте: {n} место|На карте: {n} места|На карте: {n} мест": [
    "Į žemėlapį pridėta: {n} vieta|Į žemėlapį pridėta: {n} vietos|Į žemėlapį pridėta: {n} vietų",
    "Added to the map: {n} place|Added to the map: {n} places",
  ],
  "Текст": ["Tekstas", "Text"],
  "Советы из источника ({n})": ["Šaltinio patarimai ({n})", "Tips from the source ({n})"],
  "Найденные места": ["Rastos vietos", "Places found"],
  "скрыть с карты": ["slėpti žemėlapyje", "hide from map"],
  "показать на карте": ["rodyti žemėlapyje", "show on map"],
  "на карте": ["žemėlapyje", "on the map"],
  "не найдено на карте": ["nerasta žemėlapyje", "not found on the map"],
  "координаты примерные": ["apytikslės koordinatės", "approximate location"],
  "Поставить на карту: {n}": ["Pažymėti žemėlapyje: {n}", "Add to map: {n}"],
  "Смотреть": ["Žiūrėti", "Watch"],
  "Заменить текст": ["Pakeisti tekstą", "Replace text"],
  "Вставить транскрипт": ["Įklijuoti nuorašą", "Paste transcript"],
  "Повторить": ["Bandyti dar kartą", "Retry"],
  "Вставьте транскрипт видео (YouTube → … → Показать текст видео) или текст статьи": [
    "Įklijuokite vaizdo įrašo nuorašą (YouTube → … → Rodyti nuorašą) arba straipsnio tekstą",
    "Paste the video transcript (YouTube → … → Show transcript) or the article text",
  ],
  "Разобрать этот текст": ["Išanalizuoti šį tekstą", "Process this text"],
  "Этот источник уже добавлен": ["Šis šaltinis jau pridėtas", "This source has already been added"],
  "Добавить материал": ["Pridėti šaltinį", "Add source"],
  "Название (необязательно)": ["Pavadinimas (nebūtinas)", "Title (optional)"],
  "Ссылка на YouTube или статью": ["YouTube vaizdo įrašo ar straipsnio nuoroda", "Link to a YouTube video or article"],
  "Разобрать": ["Išanalizuoti", "Process"],
  "Вставьте текст: заметки, переписку, транскрипт, список мест…": [
    "Įklijuokite tekstą: užrašus, susirašinėjimą, nuorašą, vietų sąrašą…",
    "Paste text: notes, chats, a transcript, a list of places…",
  ],
  "← по ссылке": ["← pagal nuorodą", "← from a link"],
  "или вставить текст": ["arba įklijuoti tekstą", "or paste text"],
  "ИИ сделает выжимку, найдёт места с таймкодами и предложит поставить их на карту. Текст источника не может управлять ассистентом.": [
    "DI parengs santrauką, ras vietas su laiko žymomis ir pasiūlys jas pažymėti žemėlapyje. Šaltinio tekstas negali valdyti asistento.",
    "The AI will write a summary, find places with timestamps and offer to add them to the map. Source text cannot control the assistant.",
  ],
  "Источники · {n}": ["Šaltiniai · {n}", "Sources · {n}"],
  "Пока ничего": ["Kol kas nieko", "Nothing yet"],
  "Вставьте ссылку на видео-обзор Вьетнама — получите выжимку и места на карте.": [
    "Įklijuokite nuorodą į vaizdo apžvalgą apie Vietnamą – gausite santrauką ir vietas žemėlapyje.",
    "Paste a link to a video review of Vietnam — you'll get a summary and places on the map.",
  ],
  "ИИ-виджеты · {n}": ["DI valdikliai · {n}", "AI widgets · {n}"],
  "Попросите ИИ: «сделай виджет-сравнение…», «посчитай бюджет виджетом» — он соберёт интерактивную страницу.": [
    "Paprašykite DI: „sukurk palyginimo valdiklį…“, „suskaičiuok biudžetą valdikliu“ – jis sukurs interaktyvų puslapį.",
    "Ask the AI: “make a comparison widget…”, “calculate the budget in a widget” — it will build an interactive page.",
  ],
  "вся поездка": ["visa kelionė", "whole trip"],

  // чат с ИИ (chat/ChatPanel.tsx, chat/chatStore.ts)
  "Проверь маршрут: где слишком плотно, а где мы теряем время?": [
    "Patikrink maršrutą: kur per daug įtempta, o kur gaištame laiką?",
    "Check the route: where is it too packed and where are we wasting time?",
  ],
  "Сделай виджет-калькулятор бюджета поездки на 4 человек": [
    "Sukurk kelionės biudžeto skaičiuoklės valdiklį 4 žmonėms",
    "Make a trip budget calculator widget for 4 people",
  ],
  "Какие визы нужны гражданам Литвы? Проверь по официальным источникам": [
    "Kokių vizų reikia Lietuvos piliečiams? Patikrink oficialiuose šaltiniuose",
    "What visas do Lithuanian citizens need? Check official sources",
  ],
  "Добавь 5 лучших мест с фо и бун ча в Ханое": [
    "Pridėk 5 geriausias vietas Hanojuje, kur paragauti pho ir bún chả",
    "Add the 5 best places for pho and bún chả in Hanoi",
  ],
  "Сравни варианты Ха Жанг: с водителем или самим — виджетом с выбором": [
    "Palygink Ha Giango variantus: su vairuotoju ar patiems – valdikliu su pasirinkimu",
    "Compare Ha Giang options: with a driver or on our own — as a widget with a choice",
  ],
  "Какая погода будет в апреле по регионам маршрута?": [
    "Kokie orai bus balandį skirtinguose maršruto regionuose?",
    "What will the weather be like in April in each region of the route?",
  ],
  "Размышляю…": ["Galvoju…", "Thinking…"],
  "Ход мысли": ["Minčių eiga", "Reasoning"],
  "Изменений: {n}": ["Pakeitimų: {n}", "Changes: {n}"],
  "· отменено": ["· atšaukta", "· undone"],
  "Отменить всё": ["Atšaukti viską", "Undo all"],
  "ИИ-ассистент": ["DI asistentas", "AI assistant"],
  "Новый разговор": ["Naujas pokalbis", "New conversation"],
  "История чатов": ["Pokalbių istorija", "Chat history"],
  "Пока нет разговоров": ["Pokalbių dar nėra", "No conversations yet"],
  "Новый чат": ["Naujas pokalbis", "New chat"],
  "Закрыть чат": ["Uždaryti pokalbį", "Close chat"],
  "ИИ ещё не подключён.": ["DI dar neprijungtas.", "AI is not connected yet."],
  "Как только на сервере появится ключ Claude API, здесь заработает ассистент с доступом к карте и плану.": [
    "Kai tik serveryje atsiras Claude API raktas, čia pradės veikti asistentas, galintis naudotis žemėlapiu ir planu.",
    "As soon as a Claude API key is added on the server, an assistant with access to the map and plan will start working here.",
  ],
  "Привет, {name}! Я вижу всю поездку и могу её менять.": ["Labas, {name}! Matau visą kelionę ir galiu ją keisti.", "Hi, {name}! I can see the whole trip and change it."],
  "Привет! Я вижу всю поездку и могу её менять.": ["Labas! Matau visą kelionę ir galiu ją keisti.", "Hi! I can see the whole trip and change it."],
  "Добавлю места, перестрою дни, разберу YouTube-видео или статью, найду актуальную информацию и соберу интерактивный виджет с расчётами. Все мои изменения можно отменить одной кнопкой.": [
    "Pridėsiu vietų, pertvarkysiu dienas, išanalizuosiu YouTube vaizdo įrašą ar straipsnį, rasiu naujausią informaciją ir sukursiu interaktyvų valdiklį su skaičiavimais. Visus mano pakeitimus galima atšaukti vienu mygtuku.",
    "I can add places, rearrange days, break down a YouTube video or article, find up-to-date information and build an interactive widget with calculations. All my changes can be undone with one click.",
  ],
  "Загружаю историю…": ["Įkeliama istorija…", "Loading history…"],
  "🧩 из виджета «{title}»": ["🧩 iš valdiklio „{title}“", "🧩 from widget “{title}”"],
  "ИИ узнает, что вы сейчас смотрите": ["DI matys, ką dabar žiūrite", "The AI will know what you're looking at"],
  "контекст для ИИ": ["kontekstas DI", "context for AI"],
  "Спросите или попросите что-то сделать… (можно вставить ссылку на YouTube)": [
    "Klauskite arba paprašykite ką nors padaryti… (galima įklijuoti YouTube nuorodą)",
    "Ask a question or request a change… (you can paste a YouTube link)",
  ],
  "Только просмотр": ["Tik peržiūra", "View only"],
  "Остановить": ["Sustabdyti", "Stop"],
  "Виджет: {title}": ["Valdiklis: {title}", "Widget: {title}"],
  "Отменено, но часть полей уже изменили другие ({n})": ["Atšaukta, bet dalį laukų kiti jau pakeitė ({n})", "Undone, but others had already changed some fields ({n})"],
  "Отменено изменений: {n}": ["Atšaukta pakeitimų: {n}", "Changes undone: {n}"],

  // виджеты (widgets/WidgetFrame.tsx)
  "(не удалось показать)": ["(nepavyko parodyti)", "(can't display)"],
  "Слишком большой ответ виджета": ["Valdiklio atsakymas per didelis", "Widget response is too large"],
  "Мой выбор в виджете": ["Mano pasirinkimas valdiklyje", "My choice in the widget"],
  "Ошибка в виджете: {error}": ["Valdiklio klaida: {error}", "Widget error: {error}"],
  "Открыть ссылку? {host}": ["Atidaryti nuorodą? {host}", "Open link? {host}"],
  "Отправить ИИ: «{label}»": ["Siųsti DI: „{label}“", "Send to AI: “{label}”"],
  "выбор в виджете": ["pasirinkimas valdiklyje", "choice in the widget"],
  "Развернуть": ["Išskleisti", "Expand"],
  "Виджет удалён": ["Valdiklis ištrintas", "Widget deleted"],
  "Доработай виджет «{title}» {ref}:": ["Patobulink valdiklį „{title}“ {ref}:", "Improve the widget “{title}” {ref}:"],
  "Доработать с ИИ": ["Tobulinti su DI", "Refine with AI"],
} satisfies Dict;
